import React, {PropTypes} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { getScreen } from '../../../actions/screenAction';
import ScreenHeader from '../Subcomponents/ScreenHeader';
import ScreenContainer from '../Subcomponents/ScreenContainer';
import ScreenInstructions from '../Subcomponents/ScreenInstructions';
import FieldGroup from '../Subcomponents/FieldGroup';
import ActionButton from '../Subcomponents/ActionButton';
import { parse, format } from 'libphonenumber-js';
import metadata from '../../../../node_modules/libphonenumber-js/metadata.full.json';
import {isValid_CPFBrazil, isValid_CNPJBrazil, isValid_Msisdn} from '../../../libs/validators/InputValidator';



class VivoEnterCredential extends React.Component {
    constructor(props) {
        super(props);
        this.getNextScreen = this.getNextScreen.bind(this);
        const queryParams = window.location.search
        .split('&')
        .reduce((params, param) => {
                let [key, value] = param.split('=');
                params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : '';
                return params;
            }, {}
        );

        const credentialTypes = JSON.parse(this.props.values.CredentialTypes);
        const credentialType = credentialTypes.length ?
                      (credentialTypes.indexOf(queryParams.option) != -1?queryParams.option : '') 
                     : '';
        this.state = {
          credential: '', 
            country: this.props.values.DefaultCountry, 
            credentialType: credentialType, 
            credentialTypes: credentialTypes,
            credentialIsValid: true};        

        this.updateCredential = this.updateCredential.bind(this);
        this.updateCredentialType = this.updateCredentialType.bind(this);
        this.populateOptions = this.populateOptions.bind(this);
    }

    populateOptions(item){
      let itemText = item;
      if(item==='Msisdn'){
        itemText = this.props.textResources.Msisdn;
      }
      else if(item==='CPF'){
        itemText = this.props.textResources.CPF;
      }
      else if(item==='CNPJ'){
        itemText = this.props.textResources.CNPJ;
      }
        return (
          <div className="u-mt2">
            <input id={item} type="radio" value={item} onChange={this.updateCredentialType} checked={item === this.state.credentialType}/>
            <label htmlFor={item} dangerouslySetInnerHTML={{__html: itemText}}></label>
          </div>);
    }
    CheckIfCredentialIsValid(value){
      if(this.state.credentialType === 'Msisdn'){
        this.setState({credentialIsValid:isValid_Msisdn(value, this.state.country)});
      }
      else if(this.state.credentialType==='CPF'){
        this.setState({credentialIsValid:isValid_CPFBrazil(value)});
      }
      else if(this.state.credentialType==='CNPJ'){
        this.setState({credentialIsValid:isValid_CNPJBrazil(value)});
      }
    }

    updateCredential(event) {
      this.CheckIfCredentialIsValid(event.target.value);

        return this.setState({credential: event.target.value});
    }

    updateCredentialType(event) { 
      return this.setState({credentialType: event.target.value},
        () => this.CheckIfCredentialIsValid(this.state.credential));
    }

    getNextScreen () {
        let currentState = {
            Values: this.state
        };
        let phone = parse(this.state.credential, this.state.country).phone;
        currentState.Values.numberAsEntered = this.state.credential;
        if(this.state.credentialType==='Msisdn'){
          let msisdnI18n = format({phone: phone, country:  this.state.country}, 'International_plaintext').substr(1);
          currentState.Values.number = msisdnI18n;
        }
        else{
          currentState.Values.number = this.state.credential;
        }
        
        this.props.actions.getScreen(currentState, this.props.name);
    }

    componentWillMount() {
      this.setState({credentialIsValid:  parse(this.state.credential, this.state.country).phone != undefined});
    }

    render() {        
        let texts = this.props.textResources;
        const TnCs =JSON.parse(this.props.uiSpec.TermsAndConditionsLinks);
        const TnCsText1 = texts.TsNCsText1.split('{VivoPrimeLinkName}');
        const TnCsText2 = texts.TsNCsText2.split('{VivoTsnCsLinkName}');
        return (
        <ScreenContainer>
            <ScreenHeader title={texts.HeaderTitle} text={texts.HeaderText} icon={this.props.uiSpec.Icon} />
            {/* <ScreenInstructions title={texts.InstructionTitle} text={texts.InstructionTextCredentialTypes}/> */}
            <div className="o-pageSection o-pageSection--form">
                <div className="u-mt4 u-mb4">{texts.SelectCredentialType}</div>
                {this.state.credentialTypes.map(this.populateOptions)}
                <FieldGroup errorText={texts.InvalidInput} valid label={texts.MobileNo}>
                       <input name="credential" type="number" className="c-Input" placeholder={texts.NumberPlaceholder} value={this.state.credential} onChange={this.updateCredential}/>
                </FieldGroup>
                <div className="TsNCs-Container">
                {TnCsText1[0]}
                  <a href={TnCs.find(t=>t.relatesTo==='VivoPrimeLinkName').Link} className="vivo-blue-links">{texts.VivoPrimeLinkName}</a>
                  {TnCsText1[1] || null}
                  {TnCsText2[0]}
                  <a href={TnCs.find(t=>t.relatesTo==='VivoTsnCsLinkName').Link} className="vivo-blue-links">{texts.VivoTsnCsLinkName}</a>
                  {TnCsText2[1] || null}
                  </div>

                <div className="o-buttonContainer u-align-center">
                    <ActionButton action={this.getNextScreen} valid={this.state.credentialIsValid} text={texts.ContinueButtonText} />
                </div>
            </div>
        </ScreenContainer>
            );
        }
}

VivoEnterCredential.propTypes = {
    name: React.PropTypes.string.isRequired,
    values: React.PropTypes.object.isRequired,
    uiSpec: React.PropTypes.object.isRequired,
    textResources: React.PropTypes.object.isRequired,
    actions: React.PropTypes.object.isRequired
};

function mapStateToProps(state, ownProps){
    return {
    };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({getScreen}, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(VivoEnterCredential);


/** WEBPACK FOOTER **
 ** ./src/components/ScreenComponents/Vivo/VivoEnterCredential.js
 **/